// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function safeDivide(
  numerator: number | null | undefined,
  denominator: number | null | undefined,
  nanValue = null,
) {
  if (numerator === null || numerator === undefined) {
    return nanValue;
  }

  if (denominator === 0 || denominator === null || denominator === undefined) {
    return nanValue;
  }

  return numerator / denominator;
}
